import api from '@/api/jobManagement'

const state = {

}

const actions = {
  getJobInfoById (context, jobId) {
    return api.getJobInfoById(jobId)
  },
  createJob (context, jobInfo) {
    return api.createJob(jobInfo)
  },
  updateJob (context, jobInfo) {
    return api.updateJob(jobInfo.id, jobInfo)
  },
  getJobLocationList (context, params) {
    return api.getJobLocationList(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
